module.exports = __webpack_public_path__ + "img/allow_permissions.5274ba1e.webp";